/**
 * get all countries in one cat for subline
 * @param  {object} obj       for instance, data["Animals"]
 * @return {array}            array in above format 
 */
/*
[
  {
    name: "Canada",
    data: [56.33, 65, 25, ...]
  }, 
  {
    name: "Mexico",
    data: [24.03, 23, 3...]
  }, 
  ...
]
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.cntsInOneCatForLine = cntsInOneCatForLine;

function cntsInOneCatForLine(obj) {

  var output = [];

  var hash = {};

  var _loop = function (subCat) {
    if (subCat !== 'total') {
      var ctns = Object.keys(obj[subCat]);
      ctns.forEach(function (c) {
        if (hash[c] === undefined) hash[c] = [];
        obj[subCat][c].forEach(function (val, index) {
          if (hash[c][index] === undefined) hash[c][index] = 0;
          hash[c][index] += val;
        });
      });
    }
  };

  for (var subCat in obj) {
    _loop(subCat);
  }

  var _loop2 = function (key) {

    var arr = [];
    hash[key].forEach(function (d) {
      arr.push(parseFloat(d.toFixed(1)));
    });

    output.push({
      name: key,
      data: arr
    });
  };

  for (var key in hash) {
    _loop2(key);
  }

  output.sort(function (a, b) {
    return b.data.reduce(function (b1, b2) {
      return b1 + b2;
    }) - a.data.reduce(function (a1, a2) {
      return a1 + a2;
    });
  });

  output = output.slice(0, 10);
  //console.dir(output)
  return output;
}
//# sourceMappingURL=data:application/json;base64,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